import { mutate as mutateGlobalCache } from 'swr'

import { RAIL_CONVERSATIONS_KEY } from './revalidateConversationLists'

/**
 * Refetches the sidebar Recent rail and nothing else. Unlike
 * `revalidateConversationLists` it leaves the room lists, the Home Lab chats
 * and the trial counter alone, so study events can refresh the rail cheaply.
 *
 * Fire-and-forget: a failed refetch leaves the previous data.
 */
export function revalidateRail(): void {
  Promise.resolve(mutateGlobalCache(RAIL_CONVERSATIONS_KEY)).catch(() => undefined)
}
